/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StartImport } from './routes/start'
import { Route as BuilderImport } from './routes/builder'
import { Route as ProtectedRouteImport } from './routes/_protected/route'
import { Route as BuilderIndexImport } from './routes/builder.index'
import { Route as BuilderSplatImport } from './routes/builder.$'
import { Route as AuthSignupImport } from './routes/auth/signup'
import { Route as AuthLogoutImport } from './routes/auth/logout'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as ProtectedSubscriptionImport } from './routes/_protected/subscription'
import { Route as ProtectedSetupSiteThemeImport } from './routes/_protected/setup-site-theme'
import { Route as ProtectedCreateSiteImport } from './routes/_protected/create-site'
import { Route as ProtectedSiteRouteImport } from './routes/_protected/_site/route'
import { Route as ProtectedSiteIndexImport } from './routes/_protected/_site/index'
import { Route as ProtectedSiteSiteDetailsImport } from './routes/_protected/_site/site-details'
import { Route as ProtectedSitePublishedImport } from './routes/_protected/_site/published'
import { Route as ProtectedSiteManageCardsImport } from './routes/_protected/_site/manage-cards'
import { Route as ProtectedSiteCustomDomainImport } from './routes/_protected/_site/custom-domain'
import { Route as ProtectedSiteAddCardIndexImport } from './routes/_protected/_site/add-card/index'
import { Route as ProtectedSiteEditCardCardIndexImport } from './routes/_protected/_site/edit-card.$cardIndex'
import { Route as ProtectedSiteAddCardCardTypeImport } from './routes/_protected/_site/add-card/$cardType'

// Create/Update Routes

const StartRoute = StartImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRoute,
} as any)

const BuilderRoute = BuilderImport.update({
  id: '/builder',
  path: '/builder',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedRouteRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRoute,
} as any)

const BuilderIndexRoute = BuilderIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BuilderRoute,
} as any)

const BuilderSplatRoute = BuilderSplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => BuilderRoute,
} as any)

const AuthSignupRoute = AuthSignupImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => rootRoute,
} as any)

const AuthLogoutRoute = AuthLogoutImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedSubscriptionRoute = ProtectedSubscriptionImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedSetupSiteThemeRoute = ProtectedSetupSiteThemeImport.update({
  id: '/setup-site-theme',
  path: '/setup-site-theme',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedCreateSiteRoute = ProtectedCreateSiteImport.update({
  id: '/create-site',
  path: '/create-site',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedSiteRouteRoute = ProtectedSiteRouteImport.update({
  id: '/_site',
  getParentRoute: () => ProtectedRouteRoute,
} as any)

const ProtectedSiteIndexRoute = ProtectedSiteIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedSiteRouteRoute,
} as any)

const ProtectedSiteSiteDetailsRoute = ProtectedSiteSiteDetailsImport.update({
  id: '/site-details',
  path: '/site-details',
  getParentRoute: () => ProtectedSiteRouteRoute,
} as any)

const ProtectedSitePublishedRoute = ProtectedSitePublishedImport.update({
  id: '/published',
  path: '/published',
  getParentRoute: () => ProtectedSiteRouteRoute,
} as any)

const ProtectedSiteManageCardsRoute = ProtectedSiteManageCardsImport.update({
  id: '/manage-cards',
  path: '/manage-cards',
  getParentRoute: () => ProtectedSiteRouteRoute,
} as any)

const ProtectedSiteCustomDomainRoute = ProtectedSiteCustomDomainImport.update({
  id: '/custom-domain',
  path: '/custom-domain',
  getParentRoute: () => ProtectedSiteRouteRoute,
} as any)

const ProtectedSiteAddCardIndexRoute = ProtectedSiteAddCardIndexImport.update({
  id: '/add-card/',
  path: '/add-card/',
  getParentRoute: () => ProtectedSiteRouteRoute,
} as any)

const ProtectedSiteEditCardCardIndexRoute =
  ProtectedSiteEditCardCardIndexImport.update({
    id: '/edit-card/$cardIndex',
    path: '/edit-card/$cardIndex',
    getParentRoute: () => ProtectedSiteRouteRoute,
  } as any)

const ProtectedSiteAddCardCardTypeRoute =
  ProtectedSiteAddCardCardTypeImport.update({
    id: '/add-card/$cardType',
    path: '/add-card/$cardType',
    getParentRoute: () => ProtectedSiteRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRoute
    }
    '/builder': {
      id: '/builder'
      path: '/builder'
      fullPath: '/builder'
      preLoaderRoute: typeof BuilderImport
      parentRoute: typeof rootRoute
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartImport
      parentRoute: typeof rootRoute
    }
    '/_protected/_site': {
      id: '/_protected/_site'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedSiteRouteImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/create-site': {
      id: '/_protected/create-site'
      path: '/create-site'
      fullPath: '/create-site'
      preLoaderRoute: typeof ProtectedCreateSiteImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/setup-site-theme': {
      id: '/_protected/setup-site-theme'
      path: '/setup-site-theme'
      fullPath: '/setup-site-theme'
      preLoaderRoute: typeof ProtectedSetupSiteThemeImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/_protected/subscription': {
      id: '/_protected/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof ProtectedSubscriptionImport
      parentRoute: typeof ProtectedRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutImport
      parentRoute: typeof rootRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupImport
      parentRoute: typeof rootRoute
    }
    '/builder/$': {
      id: '/builder/$'
      path: '/$'
      fullPath: '/builder/$'
      preLoaderRoute: typeof BuilderSplatImport
      parentRoute: typeof BuilderImport
    }
    '/builder/': {
      id: '/builder/'
      path: '/'
      fullPath: '/builder/'
      preLoaderRoute: typeof BuilderIndexImport
      parentRoute: typeof BuilderImport
    }
    '/_protected/_site/custom-domain': {
      id: '/_protected/_site/custom-domain'
      path: '/custom-domain'
      fullPath: '/custom-domain'
      preLoaderRoute: typeof ProtectedSiteCustomDomainImport
      parentRoute: typeof ProtectedSiteRouteImport
    }
    '/_protected/_site/manage-cards': {
      id: '/_protected/_site/manage-cards'
      path: '/manage-cards'
      fullPath: '/manage-cards'
      preLoaderRoute: typeof ProtectedSiteManageCardsImport
      parentRoute: typeof ProtectedSiteRouteImport
    }
    '/_protected/_site/published': {
      id: '/_protected/_site/published'
      path: '/published'
      fullPath: '/published'
      preLoaderRoute: typeof ProtectedSitePublishedImport
      parentRoute: typeof ProtectedSiteRouteImport
    }
    '/_protected/_site/site-details': {
      id: '/_protected/_site/site-details'
      path: '/site-details'
      fullPath: '/site-details'
      preLoaderRoute: typeof ProtectedSiteSiteDetailsImport
      parentRoute: typeof ProtectedSiteRouteImport
    }
    '/_protected/_site/': {
      id: '/_protected/_site/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedSiteIndexImport
      parentRoute: typeof ProtectedSiteRouteImport
    }
    '/_protected/_site/add-card/$cardType': {
      id: '/_protected/_site/add-card/$cardType'
      path: '/add-card/$cardType'
      fullPath: '/add-card/$cardType'
      preLoaderRoute: typeof ProtectedSiteAddCardCardTypeImport
      parentRoute: typeof ProtectedSiteRouteImport
    }
    '/_protected/_site/edit-card/$cardIndex': {
      id: '/_protected/_site/edit-card/$cardIndex'
      path: '/edit-card/$cardIndex'
      fullPath: '/edit-card/$cardIndex'
      preLoaderRoute: typeof ProtectedSiteEditCardCardIndexImport
      parentRoute: typeof ProtectedSiteRouteImport
    }
    '/_protected/_site/add-card/': {
      id: '/_protected/_site/add-card/'
      path: '/add-card'
      fullPath: '/add-card'
      preLoaderRoute: typeof ProtectedSiteAddCardIndexImport
      parentRoute: typeof ProtectedSiteRouteImport
    }
  }
}

// Create and export the route tree

interface ProtectedSiteRouteRouteChildren {
  ProtectedSiteCustomDomainRoute: typeof ProtectedSiteCustomDomainRoute
  ProtectedSiteManageCardsRoute: typeof ProtectedSiteManageCardsRoute
  ProtectedSitePublishedRoute: typeof ProtectedSitePublishedRoute
  ProtectedSiteSiteDetailsRoute: typeof ProtectedSiteSiteDetailsRoute
  ProtectedSiteIndexRoute: typeof ProtectedSiteIndexRoute
  ProtectedSiteAddCardCardTypeRoute: typeof ProtectedSiteAddCardCardTypeRoute
  ProtectedSiteEditCardCardIndexRoute: typeof ProtectedSiteEditCardCardIndexRoute
  ProtectedSiteAddCardIndexRoute: typeof ProtectedSiteAddCardIndexRoute
}

const ProtectedSiteRouteRouteChildren: ProtectedSiteRouteRouteChildren = {
  ProtectedSiteCustomDomainRoute: ProtectedSiteCustomDomainRoute,
  ProtectedSiteManageCardsRoute: ProtectedSiteManageCardsRoute,
  ProtectedSitePublishedRoute: ProtectedSitePublishedRoute,
  ProtectedSiteSiteDetailsRoute: ProtectedSiteSiteDetailsRoute,
  ProtectedSiteIndexRoute: ProtectedSiteIndexRoute,
  ProtectedSiteAddCardCardTypeRoute: ProtectedSiteAddCardCardTypeRoute,
  ProtectedSiteEditCardCardIndexRoute: ProtectedSiteEditCardCardIndexRoute,
  ProtectedSiteAddCardIndexRoute: ProtectedSiteAddCardIndexRoute,
}

const ProtectedSiteRouteRouteWithChildren =
  ProtectedSiteRouteRoute._addFileChildren(ProtectedSiteRouteRouteChildren)

interface ProtectedRouteRouteChildren {
  ProtectedSiteRouteRoute: typeof ProtectedSiteRouteRouteWithChildren
  ProtectedCreateSiteRoute: typeof ProtectedCreateSiteRoute
  ProtectedSetupSiteThemeRoute: typeof ProtectedSetupSiteThemeRoute
  ProtectedSubscriptionRoute: typeof ProtectedSubscriptionRoute
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedSiteRouteRoute: ProtectedSiteRouteRouteWithChildren,
  ProtectedCreateSiteRoute: ProtectedCreateSiteRoute,
  ProtectedSetupSiteThemeRoute: ProtectedSetupSiteThemeRoute,
  ProtectedSubscriptionRoute: ProtectedSubscriptionRoute,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

interface BuilderRouteChildren {
  BuilderSplatRoute: typeof BuilderSplatRoute
  BuilderIndexRoute: typeof BuilderIndexRoute
}

const BuilderRouteChildren: BuilderRouteChildren = {
  BuilderSplatRoute: BuilderSplatRoute,
  BuilderIndexRoute: BuilderIndexRoute,
}

const BuilderRouteWithChildren =
  BuilderRoute._addFileChildren(BuilderRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof ProtectedSiteRouteRouteWithChildren
  '/builder': typeof BuilderRouteWithChildren
  '/start': typeof StartRoute
  '/create-site': typeof ProtectedCreateSiteRoute
  '/setup-site-theme': typeof ProtectedSetupSiteThemeRoute
  '/subscription': typeof ProtectedSubscriptionRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/signup': typeof AuthSignupRoute
  '/builder/$': typeof BuilderSplatRoute
  '/builder/': typeof BuilderIndexRoute
  '/custom-domain': typeof ProtectedSiteCustomDomainRoute
  '/manage-cards': typeof ProtectedSiteManageCardsRoute
  '/published': typeof ProtectedSitePublishedRoute
  '/site-details': typeof ProtectedSiteSiteDetailsRoute
  '/': typeof ProtectedSiteIndexRoute
  '/add-card/$cardType': typeof ProtectedSiteAddCardCardTypeRoute
  '/edit-card/$cardIndex': typeof ProtectedSiteEditCardCardIndexRoute
  '/add-card': typeof ProtectedSiteAddCardIndexRoute
}

export interface FileRoutesByTo {
  '': typeof ProtectedRouteRouteWithChildren
  '/start': typeof StartRoute
  '/create-site': typeof ProtectedCreateSiteRoute
  '/setup-site-theme': typeof ProtectedSetupSiteThemeRoute
  '/subscription': typeof ProtectedSubscriptionRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/signup': typeof AuthSignupRoute
  '/builder/$': typeof BuilderSplatRoute
  '/builder': typeof BuilderIndexRoute
  '/custom-domain': typeof ProtectedSiteCustomDomainRoute
  '/manage-cards': typeof ProtectedSiteManageCardsRoute
  '/published': typeof ProtectedSitePublishedRoute
  '/site-details': typeof ProtectedSiteSiteDetailsRoute
  '/': typeof ProtectedSiteIndexRoute
  '/add-card/$cardType': typeof ProtectedSiteAddCardCardTypeRoute
  '/edit-card/$cardIndex': typeof ProtectedSiteEditCardCardIndexRoute
  '/add-card': typeof ProtectedSiteAddCardIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_protected': typeof ProtectedRouteRouteWithChildren
  '/builder': typeof BuilderRouteWithChildren
  '/start': typeof StartRoute
  '/_protected/_site': typeof ProtectedSiteRouteRouteWithChildren
  '/_protected/create-site': typeof ProtectedCreateSiteRoute
  '/_protected/setup-site-theme': typeof ProtectedSetupSiteThemeRoute
  '/_protected/subscription': typeof ProtectedSubscriptionRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/signup': typeof AuthSignupRoute
  '/builder/$': typeof BuilderSplatRoute
  '/builder/': typeof BuilderIndexRoute
  '/_protected/_site/custom-domain': typeof ProtectedSiteCustomDomainRoute
  '/_protected/_site/manage-cards': typeof ProtectedSiteManageCardsRoute
  '/_protected/_site/published': typeof ProtectedSitePublishedRoute
  '/_protected/_site/site-details': typeof ProtectedSiteSiteDetailsRoute
  '/_protected/_site/': typeof ProtectedSiteIndexRoute
  '/_protected/_site/add-card/$cardType': typeof ProtectedSiteAddCardCardTypeRoute
  '/_protected/_site/edit-card/$cardIndex': typeof ProtectedSiteEditCardCardIndexRoute
  '/_protected/_site/add-card/': typeof ProtectedSiteAddCardIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/builder'
    | '/start'
    | '/create-site'
    | '/setup-site-theme'
    | '/subscription'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/signup'
    | '/builder/$'
    | '/builder/'
    | '/custom-domain'
    | '/manage-cards'
    | '/published'
    | '/site-details'
    | '/'
    | '/add-card/$cardType'
    | '/edit-card/$cardIndex'
    | '/add-card'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/start'
    | '/create-site'
    | '/setup-site-theme'
    | '/subscription'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/signup'
    | '/builder/$'
    | '/builder'
    | '/custom-domain'
    | '/manage-cards'
    | '/published'
    | '/site-details'
    | '/'
    | '/add-card/$cardType'
    | '/edit-card/$cardIndex'
    | '/add-card'
  id:
    | '__root__'
    | '/_protected'
    | '/builder'
    | '/start'
    | '/_protected/_site'
    | '/_protected/create-site'
    | '/_protected/setup-site-theme'
    | '/_protected/subscription'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/signup'
    | '/builder/$'
    | '/builder/'
    | '/_protected/_site/custom-domain'
    | '/_protected/_site/manage-cards'
    | '/_protected/_site/published'
    | '/_protected/_site/site-details'
    | '/_protected/_site/'
    | '/_protected/_site/add-card/$cardType'
    | '/_protected/_site/edit-card/$cardIndex'
    | '/_protected/_site/add-card/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  BuilderRoute: typeof BuilderRouteWithChildren
  StartRoute: typeof StartRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const rootRouteChildren: RootRouteChildren = {
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  BuilderRoute: BuilderRouteWithChildren,
  StartRoute: StartRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthSignupRoute: AuthSignupRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_protected",
        "/builder",
        "/start",
        "/auth/login",
        "/auth/logout",
        "/auth/signup"
      ]
    },
    "/_protected": {
      "filePath": "_protected/route.tsx",
      "children": [
        "/_protected/_site",
        "/_protected/create-site",
        "/_protected/setup-site-theme",
        "/_protected/subscription"
      ]
    },
    "/builder": {
      "filePath": "builder.tsx",
      "children": [
        "/builder/$",
        "/builder/"
      ]
    },
    "/start": {
      "filePath": "start.tsx"
    },
    "/_protected/_site": {
      "filePath": "_protected/_site/route.tsx",
      "parent": "/_protected",
      "children": [
        "/_protected/_site/custom-domain",
        "/_protected/_site/manage-cards",
        "/_protected/_site/published",
        "/_protected/_site/site-details",
        "/_protected/_site/",
        "/_protected/_site/add-card/$cardType",
        "/_protected/_site/edit-card/$cardIndex",
        "/_protected/_site/add-card/"
      ]
    },
    "/_protected/create-site": {
      "filePath": "_protected/create-site.tsx",
      "parent": "/_protected"
    },
    "/_protected/setup-site-theme": {
      "filePath": "_protected/setup-site-theme.tsx",
      "parent": "/_protected"
    },
    "/_protected/subscription": {
      "filePath": "_protected/subscription.tsx",
      "parent": "/_protected"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/auth/logout": {
      "filePath": "auth/logout.tsx"
    },
    "/auth/signup": {
      "filePath": "auth/signup.tsx"
    },
    "/builder/$": {
      "filePath": "builder.$.tsx",
      "parent": "/builder"
    },
    "/builder/": {
      "filePath": "builder.index.tsx",
      "parent": "/builder"
    },
    "/_protected/_site/custom-domain": {
      "filePath": "_protected/_site/custom-domain.tsx",
      "parent": "/_protected/_site"
    },
    "/_protected/_site/manage-cards": {
      "filePath": "_protected/_site/manage-cards.tsx",
      "parent": "/_protected/_site"
    },
    "/_protected/_site/published": {
      "filePath": "_protected/_site/published.tsx",
      "parent": "/_protected/_site"
    },
    "/_protected/_site/site-details": {
      "filePath": "_protected/_site/site-details.tsx",
      "parent": "/_protected/_site"
    },
    "/_protected/_site/": {
      "filePath": "_protected/_site/index.tsx",
      "parent": "/_protected/_site"
    },
    "/_protected/_site/add-card/$cardType": {
      "filePath": "_protected/_site/add-card/$cardType.tsx",
      "parent": "/_protected/_site"
    },
    "/_protected/_site/edit-card/$cardIndex": {
      "filePath": "_protected/_site/edit-card.$cardIndex.tsx",
      "parent": "/_protected/_site"
    },
    "/_protected/_site/add-card/": {
      "filePath": "_protected/_site/add-card/index.tsx",
      "parent": "/_protected/_site"
    }
  }
}
ROUTE_MANIFEST_END */
